/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./node_modules/aos/dist/aos.js":
/*!**************************************!*\
  !*** ./node_modules/aos/dist/aos.js ***!
  \**************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():0}(this,function(){"use strict";var e="undefined"!=typeof window?window:"undefined"!=typeof __webpack_require__.g?__webpack_require__.g:"undefined"!=typeof self?self:{},t="Expected a function",n=NaN,o="[object Symbol]",i=/^\s+|\s+$/g,a=/^[-+]0x[0-9a-f]+$/i,r=/^0b[01]+$/i,c=/^0o[0-7]+$/i,s=parseInt,u="object"==typeof e&&e&&e.Object===Object&&e,d="object"==typeof self&&self&&self.Object===Object&&self,l=u||d||Function("return this")(),f=Object.prototype.toString,m=Math.max,p=Math.min,b=function(){return l.Date.now()};function v(e,n,o){var i,a,r,c,s,u,d=0,l=!1,f=!1,v=!0;if("function"!=typeof e)throw new TypeError(t);function y(t){var n=i,o=a;return i=a=void 0,d=t,c=e.apply(o,n)}function h(e){var t=e-u;return void 0===u||t>=n||t<0||f&&e-d>=r}function k(){var e=b();if(h(e))return x(e);s=setTimeout(k,function(e){var t=n-(e-u);return f?p(t,r-(e-d)):t}(e))}function x(e){return s=void 0,v&&i?y(e):(i=a=void 0,c)}function O(){var e=b(),t=h(e);if(i=arguments,a=this,u=e,t){if(void 0===s)return function(e){return d=e,s=setTimeout(k,n),l?y(e):c}(u);if(f)return s=setTimeout(k,n),y(u)}return void 0===s&&(s=setTimeout(k,n)),c}return n=w(n)||0,g(o)&&(l=!!o.leading,r=(f="maxWait"in o)?m(w(o.maxWait)||0,n):r,v="trailing"in o?!!o.trailing:v),O.cancel=function(){void 0!==s&&clearTimeout(s),d=0,i=u=a=s=void 0},O.flush=function(){return void 0===s?c:x(b())},O}function g(e){var t=typeof e;return!!e&&("object"==t||"function"==t)}function w(e){if("number"==typeof e)return e;if(function(e){return"symbol"==typeof e||function(e){return!!e&&"object"==typeof e}(e)&&f.call(e)==o}(e))return n;if(g(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=g(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(i,"");var u=r.test(e);return u||c.test(e)?s(e.slice(2),u?2:8):a.test(e)?n:+e}var y=function(e,n,o){var i=!0,a=!0;if("function"!=typeof e)throw new TypeError(t);return g(o)&&(i="leading"in o?!!o.leading:i,a="trailing"in o?!!o.trailing:a),v(e,n,{leading:i,maxWait:n,trailing:a})},h="Expected a function",k=NaN,x="[object Symbol]",O=/^\s+|\s+$/g,j=/^[-+]0x[0-9a-f]+$/i,E=/^0b[01]+$/i,N=/^0o[0-7]+$/i,z=parseInt,C="object"==typeof e&&e&&e.Object===Object&&e,A="object"==typeof self&&self&&self.Object===Object&&self,q=C||A||Function("return this")(),L=Object.prototype.toString,T=Math.max,M=Math.min,S=function(){return q.Date.now()};function D(e){var t=typeof e;return!!e&&("object"==t||"function"==t)}function H(e){if("number"==typeof e)return e;if(function(e){return"symbol"==typeof e||function(e){return!!e&&"object"==typeof e}(e)&&L.call(e)==x}(e))return k;if(D(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=D(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(O,"");var n=E.test(e);return n||N.test(e)?z(e.slice(2),n?2:8):j.test(e)?k:+e}var $=function(e,t,n){var o,i,a,r,c,s,u=0,d=!1,l=!1,f=!0;if("function"!=typeof e)throw new TypeError(h);function m(t){var n=o,a=i;return o=i=void 0,u=t,r=e.apply(a,n)}function p(e){var n=e-s;return void 0===s||n>=t||n<0||l&&e-u>=a}function b(){var e=S();if(p(e))return v(e);c=setTimeout(b,function(e){var n=t-(e-s);return l?M(n,a-(e-u)):n}(e))}function v(e){return c=void 0,f&&o?m(e):(o=i=void 0,r)}function g(){var e=S(),n=p(e);if(o=arguments,i=this,s=e,n){if(void 0===c)return function(e){return u=e,c=setTimeout(b,t),d?m(e):r}(s);if(l)return c=setTimeout(b,t),m(s)}return void 0===c&&(c=setTimeout(b,t)),r}return t=H(t)||0,D(n)&&(d=!!n.leading,a=(l="maxWait"in n)?T(H(n.maxWait)||0,t):a,f="trailing"in n?!!n.trailing:f),g.cancel=function(){void 0!==c&&clearTimeout(c),u=0,o=s=i=c=void 0},g.flush=function(){return void 0===c?r:v(S())},g},W=function(){};function P(e){e&&e.forEach(function(e){var t=Array.prototype.slice.call(e.addedNodes),n=Array.prototype.slice.call(e.removedNodes);if(function e(t){var n=void 0,o=void 0;for(n=0;n<t.length;n+=1){if((o=t[n]).dataset&&o.dataset.aos)return!0;if(o.children&&e(o.children))return!0}return!1}(t.concat(n)))return W()})}function Y(){return window.MutationObserver||window.WebKitMutationObserver||window.MozMutationObserver}var _={isSupported:function(){return!!Y()},ready:function(e,t){var n=window.document,o=new(Y())(P);W=t,o.observe(n.documentElement,{childList:!0,subtree:!0,removedNodes:!0})}},B=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")},F=function(){function e(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}return function(t,n,o){return n&&e(t.prototype,n),o&&e(t,o),t}}(),I=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e},K=/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,G=/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,J=/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i,Q=/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i;function R(){return navigator.userAgent||navigator.vendor||window.opera||""}var U=new(function(){function e(){B(this,e)}return F(e,[{key:"phone",value:function(){var e=R();return!(!K.test(e)&&!G.test(e.substr(0,4)))}},{key:"mobile",value:function(){var e=R();return!(!J.test(e)&&!Q.test(e.substr(0,4)))}},{key:"tablet",value:function(){return this.mobile()&&!this.phone()}},{key:"ie11",value:function(){return"-ms-scroll-limit"in document.documentElement.style&&"-ms-ime-align"in document.documentElement.style}}]),e}()),V=function(e,t){var n=void 0;return U.ie11()?(n=document.createEvent("CustomEvent")).initCustomEvent(e,!0,!0,{detail:t}):n=new CustomEvent(e,{detail:t}),document.dispatchEvent(n)},X=function(e){return e.forEach(function(e,t){return function(e,t){var n=e.options,o=e.position,i=e.node,a=(e.data,function(){e.animated&&(function(e,t){t&&t.forEach(function(t){return e.classList.remove(t)})}(i,n.animatedClassNames),V("aos:out",i),e.options.id&&V("aos:in:"+e.options.id,i),e.animated=!1)});n.mirror&&t>=o.out&&!n.once?a():t>=o.in?e.animated||(function(e,t){t&&t.forEach(function(t){return e.classList.add(t)})}(i,n.animatedClassNames),V("aos:in",i),e.options.id&&V("aos:in:"+e.options.id,i),e.animated=!0):e.animated&&!n.once&&a()}(e,window.pageYOffset)})},Z=function(e){for(var t=0,n=0;e&&!isNaN(e.offsetLeft)&&!isNaN(e.offsetTop);)t+=e.offsetLeft-("BODY"!=e.tagName?e.scrollLeft:0),n+=e.offsetTop-("BODY"!=e.tagName?e.scrollTop:0),e=e.offsetParent;return{top:n,left:t}},ee=function(e,t,n){var o=e.getAttribute("data-aos-"+t);if(void 0!==o){if("true"===o)return!0;if("false"===o)return!1}return o||n},te=function(e,t){return e.forEach(function(e,n){var o=ee(e.node,"mirror",t.mirror),i=ee(e.node,"once",t.once),a=ee(e.node,"id"),r=t.useClassNames&&e.node.getAttribute("data-aos"),c=[t.animatedClassName].concat(r?r.split(" "):[]).filter(function(e){return"string"==typeof e});t.initClassName&&e.node.classList.add(t.initClassName),e.position={in:function(e,t,n){var o=window.innerHeight,i=ee(e,"anchor"),a=ee(e,"anchor-placement"),r=Number(ee(e,"offset",a?0:t)),c=a||n,s=e;i&&document.querySelectorAll(i)&&(s=document.querySelectorAll(i)[0]);var u=Z(s).top-o;switch(c){case"top-bottom":break;case"center-bottom":u+=s.offsetHeight/2;break;case"bottom-bottom":u+=s.offsetHeight;break;case"top-center":u+=o/2;break;case"center-center":u+=o/2+s.offsetHeight/2;break;case"bottom-center":u+=o/2+s.offsetHeight;break;case"top-top":u+=o;break;case"bottom-top":u+=o+s.offsetHeight;break;case"center-top":u+=o+s.offsetHeight/2}return u+r}(e.node,t.offset,t.anchorPlacement),out:o&&function(e,t){window.innerHeight;var n=ee(e,"anchor"),o=ee(e,"offset",t),i=e;return n&&document.querySelectorAll(n)&&(i=document.querySelectorAll(n)[0]),Z(i).top+i.offsetHeight-o}(e.node,t.offset)},e.options={once:i,mirror:o,animatedClassNames:c,id:a}}),e},ne=function(){var e=document.querySelectorAll("[data-aos]");return Array.prototype.map.call(e,function(e){return{node:e}})},oe=[],ie=!1,ae={offset:120,delay:0,easing:"ease",duration:400,disable:!1,once:!1,mirror:!1,anchorPlacement:"top-bottom",startEvent:"DOMContentLoaded",animatedClassName:"aos-animate",initClassName:"aos-init",useClassNames:!1,disableMutationObserver:!1,throttleDelay:99,debounceDelay:50},re=function(){return document.all&&!window.atob},ce=function(){arguments.length>0&&void 0!==arguments[0]&&arguments[0]&&(ie=!0),ie&&(oe=te(oe,ae),X(oe),window.addEventListener("scroll",y(function(){X(oe,ae.once)},ae.throttleDelay)))},se=function(){if(oe=ne(),de(ae.disable)||re())return ue();ce()},ue=function(){oe.forEach(function(e,t){e.node.removeAttribute("data-aos"),e.node.removeAttribute("data-aos-easing"),e.node.removeAttribute("data-aos-duration"),e.node.removeAttribute("data-aos-delay"),ae.initClassName&&e.node.classList.remove(ae.initClassName),ae.animatedClassName&&e.node.classList.remove(ae.animatedClassName)})},de=function(e){return!0===e||"mobile"===e&&U.mobile()||"phone"===e&&U.phone()||"tablet"===e&&U.tablet()||"function"==typeof e&&!0===e()};return{init:function(e){return ae=I(ae,e),oe=ne(),ae.disableMutationObserver||_.isSupported()||(console.info('\n      aos: MutationObserver is not supported on this browser,\n      code mutations observing has been disabled.\n      You may have to call "refreshHard()" by yourself.\n    '),ae.disableMutationObserver=!0),ae.disableMutationObserver||_.ready("[data-aos]",se),de(ae.disable)||re()?ue():(document.querySelector("body").setAttribute("data-aos-easing",ae.easing),document.querySelector("body").setAttribute("data-aos-duration",ae.duration),document.querySelector("body").setAttribute("data-aos-delay",ae.delay),-1===["DOMContentLoaded","load"].indexOf(ae.startEvent)?document.addEventListener(ae.startEvent,function(){ce(!0)}):window.addEventListener("load",function(){ce(!0)}),"DOMContentLoaded"===ae.startEvent&&["complete","interactive"].indexOf(document.readyState)>-1&&ce(!0),window.addEventListener("resize",$(ce,ae.debounceDelay,!0)),window.addEventListener("orientationchange",$(ce,ae.debounceDelay,!0)),oe)},refresh:ce,refreshHard:se}});


/***/ }),

/***/ "./frontend/js/accessibity.js":
/*!************************************!*\
  !*** ./frontend/js/accessibity.js ***!
  \************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
var init = function init() {
  /**
   * Accordion keyboard support
   */
  var accordions = document.querySelectorAll(".tab-label");
  if (accordions.length > 0) {
    accordions.forEach(function (accordion) {
      accordion.addEventListener("keydown", function (e) {
        e.preventDefault();

        // when clicking enter key, toggle the accordion
        if (e.keyCode === 13) {
          accordion.click();
        }
      });
    });
  }
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  init: init
});

/***/ }),

/***/ "./frontend/js/app.js":
/*!****************************!*\
  !*** ./frontend/js/app.js ***!
  \****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _product_carousel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./product-carousel */ "./frontend/js/product-carousel.js");
/* harmony import */ var _accessibity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./accessibity */ "./frontend/js/accessibity.js");
/* harmony import */ var aos__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! aos */ "./node_modules/aos/dist/aos.js");
/* harmony import */ var aos__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(aos__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _promo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./promo */ "./frontend/js/promo.js");
/* harmony import */ var _newsletter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./newsletter */ "./frontend/js/newsletter.js");
/* harmony import */ var _categories__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./categories */ "./frontend/js/categories.js");
/* harmony import */ var _back__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./back */ "./frontend/js/back.js");
/* harmony import */ var _wave__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./wave */ "./frontend/js/wave.js");
/* harmony import */ var _upsell__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./upsell */ "./frontend/js/upsell.js");
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }









document.addEventListener("DOMContentLoaded", function () {
  _product_carousel__WEBPACK_IMPORTED_MODULE_0__["default"].init();
  _accessibity__WEBPACK_IMPORTED_MODULE_1__["default"].init();
  _promo__WEBPACK_IMPORTED_MODULE_3__["default"].init();
  _newsletter__WEBPACK_IMPORTED_MODULE_4__["default"].init();
  _categories__WEBPACK_IMPORTED_MODULE_5__["default"].init();
  _back__WEBPACK_IMPORTED_MODULE_6__["default"].init();
  (0,_wave__WEBPACK_IMPORTED_MODULE_7__["default"])();
  _upsell__WEBPACK_IMPORTED_MODULE_8__["default"].init();
  aos__WEBPACK_IMPORTED_MODULE_2___default().init({
    delay: 400
  });

  // handle carousel paddings
  var time = 0;
  var pingReset = null;
  pingReset = setInterval(function () {
    window.dispatchEvent(new Event("resize"));
    time++;
    if (time > 10) {
      pingReset && clearInterval(pingReset);
    }
  }, 400);

  // remove empt
  var removeIfNoSlides = document.querySelectorAll(".remove-if-no-slides");
  if (removeIfNoSlides) {
    removeIfNoSlides.forEach(function (el) {
      if (el.querySelectorAll(".flickity-slider > *").length === 0) {
        el.remove();
      }
    });
  }
  var tabBlocks = document.querySelectorAll(".tab-content");
  tabBlocks.forEach(function (block) {
    var breakTab = block.querySelector("h2");
    if (breakTab) {
      var closeTab = breakTab.closest(".tab");
      if (closeTab) {
        closeTab.after(breakTab);
      }
    }
  });
  document.querySelectorAll(".tabs h2").forEach(function (el) {
    el.classList.add("h3");
  });
  var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  if (isSafari) {
    document.body.classList.add("safari");
  }
  setTimeout(function () {
    document.body.classList.add("loaded");
  }, 100);
  document.body.addEventListener("click", function (e) {
    var _e$target, _e$target3;
    // if we click on a [data-snippet=card-product div.card__content] element then we trigger the click
    // on the child a tag
    if ((_e$target = e.target) !== null && _e$target !== void 0 && _e$target.closest("[data-snippet=card-product] div.card__content")) {
      var _e$target2;
      var cardLink = (_e$target2 = e.target) === null || _e$target2 === void 0 ? void 0 : _e$target2.querySelector("a");
      if (cardLink) {
        e.preventDefault();
        cardLink.click();
      }
    }

    // carousel navigation button, then we need to cycle the images
    if ((_e$target3 = e.target) !== null && _e$target3 !== void 0 && _e$target3.classList.contains("carousel-navigation__button")) {
      var _e$target4;
      var cardWrapper = (_e$target4 = e.target) === null || _e$target4 === void 0 ? void 0 : _e$target4.closest(".card-wrapper");
      if (cardWrapper) {
        var image = cardWrapper.querySelector(".card__media .active-img");

        // if we have an image, then we need to cycle the display image to either
        // the next image or the first image
        if (image) {
          var images = cardWrapper.querySelectorAll(".card__media img");
          if (images.length > 1) {
            var nextImage = null;
            for (var i = 0; i < images.length; i++) {
              if (images[i] === image) {
                nextImage = i + 1 >= images.length ? images[0] : images[i + 1];
                break;
              }
            }
            if (nextImage) {
              image.classList.remove("active-img");
              image.classList.add("alt-image");
              nextImage.classList.add("active-img");
              nextImage.classList.remove("alt-image");
            }
          }
        }
      }
    }
  });
});

// Algolia
Douglas.current_tags = Douglas.current_tags || [];
Douglas.ALGOLIA_APP_ID = "2PA2FJHX48";
Douglas.ALGOLIA_API_KEY = "6c360ecab592dcfb5fcf7f80a5f31207";
Douglas.ALGOLIA_PRODUCTS_INDEX = "phloe_shopify_products";
Douglas.ALGOLIA_COLLECTIONS_INDEX = "phloe_shopify_collections";
Douglas.ALGOLIA_ARTICLES_INDEX = "phloe_shopify_articles";
Douglas.AlgoClient = algoliasearch(Douglas.ALGOLIA_APP_ID, Douglas.ALGOLIA_API_KEY);
Douglas.qs = new URLSearchParams(window.location.search);

// HTML to element
Douglas.htmlToElement = function (html) {
  var template = document.createElement("template");
  html = html.trim();
  template.innerHTML = html;
  return template.content;
};
Douglas.triggerSearch = function (q) {
  var indexes = [Douglas.ALGOLIA_PRODUCTS_INDEX, Douglas.ALGOLIA_COLLECTIONS_INDEX, Douglas.ALGOLIA_ARTICLES_INDEX];
  var queries = [];
  for (var _i = 0, _indexes = indexes; _i < _indexes.length; _i++) {
    var index = _indexes[_i];
    var query = {
      indexName: index,
      query: q,
      hitsPerPage: 6,
      params: {
        distinct: true
      }
    };
    queries.push(query);
  }
  Douglas.AlgoClient.multipleQueries(queries).then(function (_ref) {
    var results = _ref.results;
    var _iterator = _createForOfIteratorHelper(results),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var result = _step.value;
        switch (result.index) {
          case Douglas.ALGOLIA_COLLECTIONS_INDEX:
            var categoryCount = document.getElementById("template-search__results-cateory-count");
            if (categoryCount) {
              categoryCount.innerText = result.nbHits;
            }
            var categoryTemplate = document.getElementById("template-search__category-item");
            var resultCategories = document.querySelector(".template-search__results-categories");
            var _iterator2 = _createForOfIteratorHelper(result.hits),
              _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var _collection = _step2.value;
                var $ctemplate = categoryTemplate.content.firstElementChild.cloneNode(true);
                var $a = $ctemplate.querySelector("a");
                var $i = $ctemplate.querySelector("i");
                $a.href = "/collections/" + _collection.handle;
                $a.classList.add("collection__" + _collection.handle);
                $ctemplate.querySelector("span").innerHTML = _collection.title;
                var collectionRecord = Douglas.collections[_collection.title];
                if (collectionRecord) {
                  var collectionIcon = collectionRecord.icon;
                  if (collectionIcon) {
                    $i.style = "-webkit-mask-image: url(" + collectionIcon + ");mask:url(" + collectionIcon + ")";
                    if (resultCategories) {
                      resultCategories.appendChild($ctemplate);
                    }
                  }
                }
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
            break;
          case Douglas.ALGOLIA_PRODUCTS_INDEX:
            var hits = result.hits.filter(function (hit) {
              return hit.template_suffix !== "not-indexed";
            });
            var counted = document.getElementById("template-search__results-product-count");
            if (counted) {
              counted.innerHTML = hits.length;
            }
            var existijng = document.querySelectorAll(".template-search__results-products > li");

            // remove existing
            if (existijng) {
              existijng.forEach(function (el) {
                el.remove();
              });
            }
            var _iterator3 = _createForOfIteratorHelper(hits),
              _step3;
            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var product = _step3.value;
                var $templateHolder = document.getElementById("template-search__product-item");
                if (!$templateHolder) {
                  console.error("No #template-search__product-item template found for showing search results");
                  continue;
                }
                var _$template = $templateHolder.content.firstElementChild.cloneNode(true);
                var _$a = _$template.querySelector("a");
                var $img = _$template.querySelector("img");
                var collection = Douglas.collections[product.product_type];
                if (typeof collection !== "undefined") {
                  _$a.href = "/collections/" + collection.handle + "/products/" + product.handle;
                } else {
                  _$a.href = "/products/" + product.handle;
                }
                $img.src = product.product_image;
                $img.alt = product.title;
                _$template.querySelector("h5").innerHTML = product.title;
                if (product.meta.my_fields !== undefined) {
                  _$template.querySelector("p").innerHTML = product.meta.my_fields.product_excerpt;
                }

                // Append
                document.querySelector(".template-search__results-products").appendChild(_$template);
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
            break;
          case Douglas.ALGOLIA_ARTICLES_INDEX:
            var count = document.getElementById("template-search__results-article-count");
            var articleTemplate = document.getElementById("template-search__article-item");
            if (count) {
              count.innerHTML = result.nbHits;
            }
            var _iterator4 = _createForOfIteratorHelper(result.hits),
              _step4;
            try {
              for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                var article = _step4.value;
                if (!articleTemplate) {
                  console.error("No #template-search__article-item template found for showing search results");
                  return;
                }
                var $template = articleTemplate.content.firstElementChild.cloneNode(true);
                $template.querySelector("a").href = "/blogs/" + article.blog.handle + "/" + article.handle;
                if (article.image) {
                  $template.querySelector("img").src = article.image;
                }
                $template.querySelector("h5").innerHTML = article.title;
                var $body = Douglas.htmlToElement(article.body_html);
                var h5 = $body.querySelector("h5");
                $template.querySelector("p").innerHTML = h5 ? h5.innerHTML : "";
                if (article.author.name) {
                  if (article.author.name == "AKQA Wellington") {
                    article.author.name = "Jane Cronin";
                  }
                  $template.querySelector("strong").innerHTML = article.author.name;
                }
                if (article.meta && typeof article.meta.custom !== "undefined" && typeof article.meta.custom.custom_author !== "undefined") {
                  $template.querySelector("strong").innerHTML = article.meta.custom.custom_author;
                }
                var articleDate = new Date(article.published_at).toString().split(" ");
                $template.querySelector("span").innerHTML = articleDate[1] + " " + articleDate[2];

                // Read Time
                var readTime = "";
                if (article.meta.my_fields !== undefined && article.meta.my_fields.blog_time !== undefined) {
                  readTime = article.meta.my_fields.blog_time;
                }
                var read = $template.querySelector(".article__read_time");
                if (read) {
                  if (readTime === "") {
                    read.remove();
                  } else {
                    read.innerHTML = readTime;
                  }
                }

                // text description
                var text = $template.querySelector(".predictive-text-match");
                if (text) {
                  var textContent = article.body_html.replace(/<[^>]*>/g, "");
                  text.innerHTML = textContent.substring(0, 150) + "...";
                }

                // Append
                var articles = document.querySelector(".template-search__results-articles");
                if (articles) {
                  articles.appendChild($template);
                }
              }
            } catch (err) {
              _iterator4.e(err);
            } finally {
              _iterator4.f();
            }
            break;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  });
};

// Main Search
if (document.getElementById("template-search") !== null) {
  if (Douglas.qs.has("q")) {
    Douglas.triggerSearch(Douglas.qs.get("q"));
  }
}
Douglas.renderNoResults = function () {
  var msg = document.createElement("div");
  msg.innerHTML = '<div class="no-results"><h3>No results found</h3><p>Try adjusting your search or filter to find what you are looking for.</p></div>';
  return msg;
};

// Render products
Douglas.renderProductHits = function (hits, _productGrid, isFirst) {
  var $productCard = document.getElementById("template-product-card");
  if (!$productCard) {
    console.error("No #template-product-card template found for showing product results");
    return false;
  }
  var selectedSort = document.querySelector("[name=sort]:checked");
  _productGrid.innerHTML = "";
  // if no keyword query string, sort hits by the order given in DEFAULT_COLLECTION_ORDER
  if (!Douglas.qs.has("q") && (!selectedSort || selectedSort.value == "popular")) {
    if (window.DEFAULT_COLLECTION_ORDER) {
      hits = hits.sort(function (a, b) {
        return window.DEFAULT_COLLECTION_ORDER.indexOf(a.id) - window.DEFAULT_COLLECTION_ORDER.indexOf(b.id);
      });
    }
  }
  if (!hits || !hits.length) {
    if (!isFirst) {
      _productGrid.innerHTML = "";
      _productGrid.appendChild(Douglas.renderNoResults());
    }
    return;
  } else {
    _productGrid.innerHTML = "";
  }
  hits.forEach(function (product, productIndex) {
    var type = Douglas.collections[product.product_type];
    var typeHandle = type && typeof type.handle !== "undefined" ? type.handle : "all";
    var _productCard = $productCard.content.firstElementChild.cloneNode(true);
    var _productHeadings = _productCard.querySelectorAll(".card__heading");
    var _productColor = "";
    var _productId = "";
    if (_productCard.firstElementChild && _productCard.firstElementChild.dataset) {
      _productColor = _productCard.firstElementChild.dataset.cardColor;
      _productId = _productCard.firstElementChild.dataset.cardId;
    }
    var _replaceColor = type && typeof type.color !== "undefined" ? type.color : "";
    var _productUrl = "";
    if (product) {
      _productUrl = "/collections/" + typeHandle + "/products/" + product.handle;
    }
    // Links/Titles
    _productHeadings.forEach(function (_productHeading) {
      var _productLink = _productHeading.querySelector("a");
      _productLink.href = _productUrl;
      _productLink.innerHTML = product.title;
    });

    // ID
    var idRegex = new RegExp(_productId, "g");
    _productCard.innerHTML = _productCard.innerHTML.replace(idRegex, product.id);

    // Type
    var typeDom = _productCard.querySelector(".product__type");
    var meta = product.meta;
    if (meta && meta.custom) {
      if (meta.custom.colour) {
        var themeColor = meta.custom.colour;
        _productCard.querySelector(".card").classList.add("has-colors");
        if (themeColor) {
          setTimeout(function () {
            var productMedia = _productCard.querySelector(".card--media");
            productMedia.style.setProperty("--product-type-colour", themeColor);
          }, 300);
        }
      }
      if (meta.custom.colour_light) {
        var lightColour = meta.custom.colour_light;
        if (lightColour) {
          // set css var
          _productCard.style.setProperty("--product-type-colour-light", lightColour);
        }
      }
    }
    if (typeDom) {
      typeDom.innerHTML = product.product_type;
      if (meta && meta.custom && meta.custom.colour) {
        typeDom.style.color = meta.custom.colour;
      }
    }

    // Badge
    var badge = _productCard.querySelector(".card__badge");
    if (badge) {
      if (product.named_tags.__label !== undefined) {
        _productCard.querySelector(".card__badge").innerHTML = '<span class="badge product__tag product__tag--custom">' + product.named_tags.__label + "</span>";
      } else {
        badge.style.display = "none";
      }
    }

    // reviews - the review value is stored
    var reviews = _productCard.querySelector(".card__rating");
    if (reviews) {
      var reviewData = window.PRODUCT_RATING_DATA.find(function (p) {
        return p.id == product.id;
      });
      if (reviewData) {
        var rating = reviewData.rating;
        if (rating && rating > 0) {
          // set the `--rating` on the .rating-star
          reviews.querySelector(".rating-star").style.setProperty("--rating", rating);
        } else {
          reviews.remove();
        }
      } else {
        reviews.remove();
      }
    }

    // Color
    var colorRegex = new RegExp(_productColor, "g");
    _productCard.innerHTML = _productCard.innerHTML.replace(colorRegex, _replaceColor);

    // Excerpt
    var except = _productCard.querySelector(".product__metafield--excerpt");
    if (except && product.meta.my_fields !== undefined) {
      except.innerHTML = product.meta.my_fields.product_excerpt;
    }

    // Image
    var img = _productCard.querySelector("img");
    if (img) {
      img.src = product.product_image;
      img.alt = product.title;
      img.removeAttribute("srcset");
      img.removeAttribute("sizes");

      // Image variants, allow scrolling through. Algolia only has a single image
      // so we look at PRODUCT_MEDIA_DATA for the rest
      var productMediaData = window.PRODUCT_MEDIA_DATA.find(function (p) {
        return p.handle == product.handle;
      });
      if (productMediaData && productMediaData.media.length > 1) {
        var secondaryImages = productMediaData.media.slice(1);
        var imgContainer = img.closest(".media");
        console.log({
          imgContainer: imgContainer
        });

        // add each image to the card
        if (imgContainer) {
          secondaryImages.forEach(function (secondaryImage) {
            imgContainer.insertAdjacentHTML("beforeend", secondaryImage);
          });

          // move the .carousel-navigation in the imgContainer to the end of the imgContainer
          var carouselNavigation = imgContainer.querySelector(".carousel-navigation");
          if (carouselNavigation) {
            imgContainer.appendChild(carouselNavigation);
          }
        }
      }
    }

    // purchasable?
    var purchasable = false;
    try {
      var productData = window.PRODUCT_VARIANT_MAPPING.find(function (p) {
        return p.id == product.id;
      });
      if (productData) {
        var variant = productData.variants.find(function (v) {
          return v.available;
        });
        var soldOut = _productCard.querySelectorAll(".price--sold-out");
        if (soldOut.length > 0) {
          soldOut.forEach(function (el) {
            el.classList.remove("price--sold-out");
          });
        }
        if (variant) {
          if (variant.available) {
            _productCard.querySelector(".price").classList.remove("price--sold-out");
          }
          var variantPrice = variant.price;
          if (variantPrice && variantPrice.toString().split(".").length > 0) {
            if (variantPrice.toString().split(".")[1] && variantPrice.toString().split(".")[1].length == 1) {
              variantPrice = variantPrice.toString() + "0";
            }
          }
          if (variant.compare_at_price) {
            var comparePrice = variant.compare_at_price;
            if (comparePrice && comparePrice.toString().split(".").length > 0) {
              if (comparePrice.toString().split(".")[1] && comparePrice.toString().split(".")[1].length == 1) {
                comparePrice = comparePrice.toString() + "0";
              }
            }
            if (comparePrice && variantPrice !== comparePrice) {
              _productCard.querySelector(".price__sale .price-item--sale").innerHTML = "$" + variantPrice;
              _productCard.querySelector(".price__sale").classList.remove("hidden");
              _productCard.querySelector(".price__sale .price-item--regular").innerHTML = "$" + comparePrice;
              _productCard.querySelector(".price").classList.add("price--on-sale");
            } else {
              _productCard.querySelector(".price__sale").classList.add("hidden");
              _productCard.querySelector(".price").classList.remove("price--on-sale");
            }
          } else {
            _productCard.querySelector(".price__sale").classList.add("hidden");
            _productCard.querySelector(".price__sale .price-item--regular").innerHTML = "";
            _productCard.querySelector(".price").classList.remove("price--on-sale");

            // Variant price
            _productCard.querySelector(".price__regular .price-item--regular").innerHTML = "$" + variantPrice;
          }
          _productCard.querySelector(".card-action").style.display = "block";
          _productCard.querySelector(".add-to-cart").setAttribute("data-variant-id", variant.id);
          purchasable = true;
        }
      }
    } catch (e) {
      console.error(e);
    }
    if (!purchasable) {
      var addToCart = _productCard.querySelector(".add-to-cart");
      if (addToCart) {
        addToCart.remove();
      }
      var price = _productCard.querySelector(".price");
      price.classList.add("price--sold-out");
      _productCard.querySelector(".card-action").style.display = "none";
      if (price) {
        price.innerHTML = '<small class="card__out-label">Out of Stock</small>';
      }
    }

    // Append
    _productGrid.appendChild(_productCard);
  });
};

// Render articles
Douglas.renderArticleHits = function (hits, _articleGrid) {
  var $articleCard = document.getElementById("template-article-card");
  _articleGrid.innerHTML = "";
  hits.forEach(function (article) {
    var _articleCard = $articleCard.content.firstElementChild.cloneNode(true),
      _articleHeadings = _articleCard.querySelectorAll(".card__heading");

    // Links/Titles
    _articleHeadings.forEach(function (_articleHeading) {
      var _articleLink = _articleHeading.querySelector("a");
      _articleLink.href = "/blogs/" + article.blog.handle + "/" + article.handle;
      _articleLink.innerHTML = article.title;
    });

    // Tag
    if (_articleCard.querySelector(".article__tag") !== null) {
      _articleCard.querySelector(".article__tag").innerHTML = article.named_tags.__label === undefined ? "" : article.named_tags.__label;
    }
    // Author
    var authorName = article.author.name;
    if (authorName == "AKQA Wellington") {
      authorName = "Jane Cronin";
    }
    if (typeof article.meta.custom !== "undefined") {
      if (typeof article.meta.custom.author !== "undefined") {
        authorName = article.meta.custom.author;
      }
    }

    // if author name is a gid then look it up in PEOPLE array
    if (authorName && authorName.match(/gid:\/\/shopify\//)) {
      var authorId = authorName.split("gid://shopify/Metaobject/")[1];
      var author = (window.PEOPLE || []).find(function (p) {
        return p.id == authorId;
      });
      console.log({
        authorId: authorId,
        author: author
      });
      if (author) {
        authorName = author.name;
      }
    }
    _articleCard.querySelector(".article__author").innerHTML = authorName;

    // Date
    var _articleDate = new Date(article.published_at).toString().split(" ");
    _articleCard.querySelector(".article__date").innerHTML = _articleDate[1] + " " + _articleDate[2];

    // Image
    _articleCard.querySelector("img").src = article.image;
    _articleCard.querySelector("img").alt = article.title;
    _articleCard.querySelector("img").removeAttribute("srcset");
    _articleCard.querySelector("img").removeAttribute("sizes");

    // Read Time
    var readTime = "";
    if (article.meta.my_fields !== undefined && article.meta.my_fields.blog_time !== undefined) {
      readTime = article.meta.my_fields.blog_time;
    }
    var readDom = _articleCard.querySelector(".article__read_time");
    if (readDom) {
      if (readTime === "") {
        _articleCard.querySelector(".article__read_time").remove();
      } else {
        _articleCard.querySelector(".article__read_time").innerHTML = readTime;
      }
    }

    // Append
    _articleGrid.appendChild(_articleCard);
  });
};

// Show quiz results
Douglas.showQuizResults = function (criteria) {
  document.body.classList.add("quiz-finished");
  var queries = [],
    goals = [],
    andFilters = [];

  // AND filters
  for (var _i2 = 0, _Object$entries = Object.entries(criteria.tags); _i2 < _Object$entries.length; _i2++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i2], 2),
      index = _Object$entries$_i[0],
      tag = _Object$entries$_i[1];
    andFilters.push("named_tags.Quiz:" + tag);
  }

  // OR filters
  for (var _i3 = 0, _Object$entries2 = Object.entries(criteria.goals); _i3 < _Object$entries2.length; _i3++) {
    var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i3], 2),
      goal = _Object$entries2$_i[0],
      tags = _Object$entries2$_i[1];
    goals.push(goal);
    var orFilters = [];
    var _iterator5 = _createForOfIteratorHelper(tags),
      _step5;
    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var _tag = _step5.value;
        orFilters.push("named_tags.Quiz:" + _tag);
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }
    var facetFilters = [].concat(andFilters);
    facetFilters.push(orFilters);
    var query = {
      indexName: Douglas.ALGOLIA_PRODUCTS_INDEX,
      params: {
        hitsPerPage: 3,
        distinct: true,
        facetFilters: facetFilters
      }
    };
    queries.push(query);

    // update the url
    if ("URLSearchParams" in window) {
      var searchParams = new URLSearchParams(window.location.search);
      searchParams.set("quizStep", "finished");
      var newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
      history.pushState(null, "", newRelativePathQuery);
    }
  }
  Douglas.AlgoClient.multipleQueries(queries).then(function (_ref2) {
    var results = _ref2.results;
    var sections = document.getElementById("MainContent").querySelectorAll(".shopify-section");
    sections[0].style.display = "none"; // Landing
    sections[1].style.display = "block"; // Quiz
    sections[2].style.display = "block"; // Results
    sections[3].style.display = "block"; // Next Steps
    sections[4].style.display = "block"; // Retake
    sections[5].style.display = "block"; // Retake

    // Set heading text
    sections[2].querySelector(".banner__heading").innerHTML = criteria.heading;

    // Render results
    if ("content" in document.createElement("template")) {
      var $productGrid = document.getElementById("template-quiz-product-grid"),
        $noResults = document.getElementById("template-quiz-no-results");
    } else {
      console.error("<template> not supported by this browser");
      return false;
    }
    results.forEach(function (response, index) {
      var $productGridHeading = document.createElement("h4"),
        _productGrid = $productGrid.content.firstElementChild.cloneNode(true),
        $productGridViewAll = document.createElement("a");
      $productGridHeading.className = "text-center";
      $productGridHeading.innerHTML = "For help with " + goals[index];
      _productGrid.prepend($productGridHeading);
      if (response.hits.length === 0) {
        // No results
        var _noResults = $noResults.content.firstElementChild.cloneNode(true);
        _productGrid.appendChild(_noResults);
      } else {
        // View all
        _productGrid.appendChild($productGridViewAll);
        $productGridViewAll.className = "quiz-view-all";
        $productGridViewAll.innerHTML = "<span>Browse all products within this category</span>" + '<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg>';
        $productGridViewAll.href = "/search?q=" + encodeURIComponent(goals[index]);
        Douglas.renderProductHits(response.hits, _productGrid.querySelector("ul"), false);
      }

      // Append grid
      sections[2].appendChild(_productGrid);
    });
  });
};
if (document.getElementById("template-page-quiz") !== null) {
  if (Douglas.qs.has("test")) {
    Douglas.showQuizResults({
      heading: "Ryan, here's what we've chosen for you",
      tags: ["Female"],
      goals: {
        "Memory & Concentration": ["Memory & Concentration", "Stress & Mood"],
        Hair: ["Hair breakage", "Repigmenting hair"]
      }
    });
  }
}

// Custom refinements
var customRefinementList = instantsearch.connectors.connectRefinementList(function (renderOptions, isFirstRender) {
  var items = renderOptions.items,
    refine = renderOptions.refine,
    widgetParams = renderOptions.widgetParams;
  var productLoading = document.querySelector(".product-loading-overlay");
  if (isFirstRender) {
    // Initial setup, show the loading icon
    productLoading ? productLoading.classList.remove("hidden") : "";
    return;
  }
  if (!widgetParams.container) {
    return;
  }
  widgetParams.container.innerHTML = items.map(function (item) {
    return "\n          <li class=\"filter\">\n            <label class=\"filter-label\">\n        ".concat(item.label, "\n        <input type=\"checkbox\" class=\"filter-checkbox\" value=\"").concat(item.value, "\" ").concat(item.isRefined ? "checked" : "", ">\n              <span>\n                <svg width=\"8\" height=\"7\" viewBox=\"0 0 8 7\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                  <path d=\"M6.87259 0.655258C6.92077 0.606102 6.97827 0.56705 7.04173 0.540391C7.10518 0.513732 7.17332 0.5 7.24215 0.5C7.31098 0.5 7.37912 0.513732 7.44257 0.540391C7.50603 0.56705 7.56353 0.606102 7.61171 0.655258C7.8136 0.859273 7.81643 1.18894 7.61876 1.39649L3.44459 6.33095C3.3972 6.38299 3.33969 6.42482 3.27557 6.45387C3.21146 6.48292 3.1421 6.49859 3.07172 6.49991C3.00135 6.50123 2.93144 6.48818 2.86628 6.46156C2.80113 6.43493 2.74208 6.3953 2.69277 6.34507L0.152829 3.77124C0.0548714 3.67134 0 3.53701 0 3.3971C0 3.25719 0.0548714 3.12285 0.152829 3.02295C0.201006 2.9738 0.258506 2.93475 0.321962 2.90809C0.385418 2.88143 0.453555 2.8677 0.522384 2.8677C0.591213 2.8677 0.65935 2.88143 0.722806 2.90809C0.786263 2.93475 0.843762 2.9738 0.891939 3.02295L3.04644 5.2064L6.85848 0.670789C6.86287 0.665333 6.86758 0.660147 6.87259 0.655258Z\" fill=\"white\"/>\n                </svg>\n              </span>\n            </label>\n          </li>");
  }).join("");
  _toConsumableArray(widgetParams.container.querySelectorAll("input")).forEach(function (element) {
    element.addEventListener("change", function (event) {
      event.preventDefault();
      refine(event.currentTarget.value);
    });
  });
  if (isFirstRender && widgetParams.current_tags !== undefined) {
    var _iterator6 = _createForOfIteratorHelper(widgetParams.current_tags),
      _step6;
    try {
      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
        var tag = _step6.value;
        var _facet = tag.split(":"),
          facetName = "named_tags." + _facet[0],
          facetValue = _facet[1];
        if (widgetParams.attribute == facetName) {
          refine(facetValue);
        }
      }
    } catch (err) {
      _iterator6.e(err);
    } finally {
      _iterator6.f();
    }
  }
  productLoading ? productLoading.classList.add("hidden") : "";
});

// Custom pagination
var customPagination = instantsearch.connectors.connectPagination(function (renderOptions) {
  var pages = renderOptions.pages,
    currentRefinement = renderOptions.currentRefinement,
    nbPages = renderOptions.nbPages,
    isFirstPage = renderOptions.isFirstPage,
    isLastPage = renderOptions.isLastPage,
    createURL = renderOptions.createURL,
    widgetParams = renderOptions.widgetParams;
  if (nbPages === 1) {
    widgetParams.container.innerHTML = "";
    return;
  }

  // if currentRefinement is less than 1, then redirect to page 1
  if (currentRefinement < 0) {
    window.location.href = createURL(1);
  }
  widgetParams.container.innerHTML = "\n<nav class=\"pagination\" role=\"navigation\" aria-label=\"Pagination\" data-current-page=\"".concat(currentRefinement, "\">\n      <ul class=\"pagination__list list-unstyled\" role=\"list\">\n      ").concat(!isFirstPage ? "\n            <li>\n              <a class=\"pagination__item pagination__item--next pagination__item-arrow link motion-reduce\"\n                href=\"".concat(createURL(currentRefinement), "\"\n                data-value=\"").concat(currentRefinement, "\">\n                <svg class=\"icon icon-caret\" width=\"8\" height=\"13\" viewBox=\"0 0 8 13\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" style=\"transform:rotate(180deg)\">\n                      <path d=\"M1.5 11.5L6.5 6.5L1.5 1.5\"  stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n                  </svg>\n              </a>\n            </li>\n            ") : "", "\n      ").concat(pages.map(function (page) {
    return "\n            <li>\n              <a class=\"pagination__item ".concat(currentRefinement === page ? "pagination__item--current" : "link", "\"\n                href=\"").concat(createURL(page + 1), "\"\n                data-value=\"").concat(page + 1, "\"\n              >\n                ").concat(page + 1, "\n              </a>\n            </li>\n          ");
  }).join(""), "\n        ").concat(!isLastPage ? "\n              <li>\n                <a class=\"pagination__item pagination__item--next pagination__item-arrow link motion-reduce\"\n                  href=\"".concat(createURL(currentRefinement + 2), "\"\n                  data-value=\"").concat(currentRefinement + 2, "\"\n                >\n                  <svg class=\"icon icon-caret\" width=\"8\" height=\"13\" viewBox=\"0 0 8 13\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                      <path d=\"M1.5 11.5L6.5 6.5L1.5 1.5\"  stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n                  </svg>\n                </a>\n              </li>\n\n              ") : "", "\n    </ul>\n  </nav>\n  ");
});

// Collection Search
if (Douglas.collection !== undefined) {
  // Product hits
  var productHits = instantsearch.connectors.connectHits(function (renderOptions, isFirstRender) {
    var hits = renderOptions.hits,
      widgetParams = renderOptions.widgetParams;

    // if sale is ticked, filter out items without a named tag
    if (document.querySelector("input[name=sale]:checked")) {
      hits = hits.filter(function (hit) {
        return hit.named_tags["__label"] !== undefined && hit.named_tags["__label"].includes("Sale");
      });
    }

    // filter by hidden
    hits = hits.filter(function (hit) {
      return hit.template_suffix !== "not-indexed";
    });
    Douglas.renderProductHits(hits, widgetParams.container, isFirstRender);
  });
  var getSelectedIndex = function getSelectedIndex() {
    var selectedIndex = Douglas.ALGOLIA_PRODUCTS_INDEX;
    var selectedSort = document.querySelector("[name=sort]:checked");
    if (!selectedSort) {
      var c = localStorage.getItem("collectionSort");
      if (c) {
        selectedSort = {
          value: c
        };
      }
    }
    if (selectedSort) {
      if (selectedSort.value == "new") {
        selectedIndex = Douglas.ALGOLIA_PRODUCTS_INDEX + "__newest";
      } else if (selectedSort.value == "price") {
        selectedIndex = Douglas.ALGOLIA_PRODUCTS_INDEX + "__cheapest";
      }
    }
    return selectedIndex;
  };
  var createProductSearch = function createProductSearch(selectedIndex) {
    Douglas.productSearch = instantsearch({
      indexName: selectedIndex,
      searchClient: Douglas.AlgoClient,
      routing: true,
      searchFunction: function searchFunction(helper) {
        helper.setIndex(selectedIndex);
        helper.search();
      }
    });
    Douglas.productSearch.addWidgets([instantsearch.widgets.configure({
      hitsPerPage: 120,
      distinct: true
      /* disjunctiveFacetsRefinements: {
        product_type:
          Douglas.collection.title !== "Our Products"
            ? [Douglas.collection.title]
            : [],
      },*/
    }), customRefinementList({
      container: document.getElementById("filter-health-interest"),
      attribute: "named_tags.Health Interest",
      limit: 500,
      sortBy: ["name:asc"]
    }), customRefinementList({
      container: document.getElementById("filter-key-ingredient"),
      attribute: "named_tags.Key Ingredient",
      limit: 500,
      sortBy: ["name:asc"]
    }), productHits({
      container: document.getElementById("product-grid")
    }), customPagination({
      container: document.querySelector(".pagination-wrapper")
    })]);
  };
  createProductSearch(getSelectedIndex());
  document.querySelectorAll('[name="sort"]').forEach(function (element) {
    element.addEventListener("change", function (event) {
      createProductSearch(getSelectedIndex());
      Douglas.productSearch.start();
    });
  });
  var sale = document.querySelector("input[name=sale]");
  if (sale) {
    sale.removeAttribute("checked");
    sale.addEventListener("change", function (event) {
      createProductSearch(getSelectedIndex());
      Douglas.productSearch.start();
    });
  }
  Douglas.productSearch.start();

  // Show the loading icon
  Douglas.productSearch.on("render", function () {
    var productLoading = document.querySelector(".product-loading-overlay");
    if (Douglas.productSearch.status === "loading" || Douglas.productSearch.status === "stalled") {
      productLoading.classList.remove("hidden");
    } else {
      productLoading.classList.add("hidden");
    }
  });
}

// Blog Search
if (document.getElementById("template-blog") !== null) {
  // Featured article to skip
  if (document.getElementById("featured-article") !== null) {
    var _featuredArticle$data;
    var featuredArticle = document.getElementById("featured-article");
    var featuredArticleHandle = featuredArticle ? (_featuredArticle$data = featuredArticle.dataset.articleHandle) === null || _featuredArticle$data === void 0 ? void 0 : _featuredArticle$data.split("/")[1] : "";
  }

  // Product hits
  var articleHits = instantsearch.connectors.connectHits(function (renderOptions, isFirstRender) {
    var hits = renderOptions.hits,
      widgetParams = renderOptions.widgetParams;
    Douglas.renderArticleHits(hits, widgetParams.container);
  });
  Douglas.articleSearch = instantsearch({
    indexName: Douglas.ALGOLIA_ARTICLES_INDEX,
    searchClient: Douglas.AlgoClient,
    routing: true
  });

  // Show the loading icon
  Douglas.articleSearch.on("render", function () {
    var articleLoading = document.querySelector(".article-loading-overlay");
    if (Douglas.articleSearch.status === "loading" || Douglas.articleSearch.status === "stalled") {
      articleLoading.classList.remove("hidden");
    } else {
      articleLoading.classList.add("hidden");
    }
  });

  // Default to "Journal" posts only
  var defaultFacets = {
    "blog.title": ["Journal"]
  };

  // If collection tags set, add to facets
  if (Douglas.current_tags !== "undefined" && Douglas.current_tags.length) {
    var _Douglas;
    var _iterator7 = _createForOfIteratorHelper((_Douglas = Douglas) === null || _Douglas === void 0 ? void 0 : _Douglas.current_tags),
      _step7;
    try {
      for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
        var tag = _step7.value;
        var facet = tag.split(":");
        if (facet[0] == "Collection") {
          if (defaultFacets["named_tags.Collection"] === undefined) {
            defaultFacets["named_tags.Collection"] = [];
          }
          defaultFacets["named_tags.Collection"].push(facet[1]);
        }
      }
    } catch (err) {
      _iterator7.e(err);
    } finally {
      _iterator7.f();
    }
  }
  Douglas.articleSearch.addWidgets([instantsearch.widgets.configure({
    hitsPerPage: 9,
    distinct: true,
    disjunctiveFacetsRefinements: defaultFacets,
    filters: "NOT handle:" + featuredArticleHandle
  }), customRefinementList({
    container: document.getElementById("filter-health-interest"),
    attribute: "named_tags.Health Interest",
    current_tags: Douglas.current_tags,
    limit: 500,
    sortBy: ["name:asc"]
  }), customRefinementList({
    container: document.getElementById("filter-topic"),
    attribute: "named_tags.Topic",
    current_tags: Douglas.current_tags,
    limit: 500,
    sortBy: ["name:asc"]
  }), articleHits({
    container: document.getElementById("blog-articles")
  }), customPagination({
    container: document.querySelector(".pagination-wrapper")
  })]);
  Douglas.articleSearch.start();
}
Douglas.hideFiltersOnMobile = function () {
  if (window.innerWidth < 750) {
    // Collection Filters
    var collectionFilters = document.getElementsByClassName("collection-filter");
    if (collectionFilters !== null) {
      for (var i = 0; i < collectionFilters.length; i++) {
        collectionFilters.item(i).className = "collection-filter closed";
      }
    }
    // Blog Filters
    var blogFilters = document.getElementById("blog-filters");
    if (blogFilters !== null) {
      document.getElementById("blog-filters").className = "closed";
    }
  }
};
document.addEventListener("DOMContentLoaded", function () {
  // Close all filters on mobile load
  Douglas.hideFiltersOnMobile();
  var printButtons = document.querySelectorAll(".button--print");
  if (printButtons) {
    printButtons.forEach(function (button) {
      button.addEventListener("click", function (e) {
        e.preventDefault();
        window.print();
      });
    });
  }
  var emailButtons = document.querySelectorAll(".button--email, a[href^='#email-results']");
  if (emailButtons) {
    emailButtons.forEach(function (button) {
      button.addEventListener("click", function (e) {
        e.preventDefault();
        Douglas.QuizApp.showEmailModal();
      });
    });
  }
  var bookBtn = document.querySelectorAll(".full-unstyled-link");
  bookBtn.forEach(function (btn) {
    if (btn.innerText === "Book") {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        if (typeof Calendly !== "undefined") {
          Calendly.initPopupWidget({
            url: "https://calendly.com/phloe"
          });
        }
      });
    }
  });
});

// Close filters on mobile resize
window.onresize = function () {
  Douglas.hideFiltersOnMobile();
};

/***/ }),

/***/ "./frontend/js/back.js":
/*!*****************************!*\
  !*** ./frontend/js/back.js ***!
  \*****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
var Back = {
  init: function init() {
    var back = document.querySelector(".klaviyo-bis-trigger");
    var modal = document.querySelector(".c-modal__backinstock");
    if (back) {
      back.addEventListener("click", function (e) {
        e.preventDefault();
        if (modal) {
          modal.classList.remove("c-modal__hidden");

          // focus on the first input
          var firstInput = modal.querySelector("input");
          if (firstInput) {
            firstInput.focus();
          }
        }
        return false;
      });
    }

    // keyboard listener, if esc, close the modal
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        if (modal) {
          modal.classList.add("c-modal__hidden");
        }
      }
    });
    var form = document.querySelector(".c-modal__backinstock-form");
    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        // if form is valid, then hide the form and show the success message
        if (form.checkValidity()) {
          var _form$querySelector$v, _form$querySelector, _form$querySelector$g, _form$querySelector2, _form$getAttribute;
          var data = {
            a: "Va4NCD",
            email: (_form$querySelector$v = (_form$querySelector = form.querySelector("#c-modal--email_email")) === null || _form$querySelector === void 0 ? void 0 : _form$querySelector.value) !== null && _form$querySelector$v !== void 0 ? _form$querySelector$v : "",
            variant: (_form$querySelector$g = (_form$querySelector2 = form.querySelector("input[name=variant]")) === null || _form$querySelector2 === void 0 ? void 0 : _form$querySelector2.getAttribute("value")) !== null && _form$querySelector$g !== void 0 ? _form$querySelector$g : "",
            platform: "shopify"
          };
          var url = (_form$getAttribute = form.getAttribute("action")) !== null && _form$getAttribute !== void 0 ? _form$getAttribute : "";
          fetch(url, {
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            },
            body: new URLSearchParams(data)
          });
          if (modal) {
            modal.classList.add("c-modal__hidden");
          }
        }
        return false;
      });
    }
  }
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Back);

/***/ }),

/***/ "./frontend/js/categories.js":
/*!***********************************!*\
  !*** ./frontend/js/categories.js ***!
  \***********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
var init = function init() {
  /**
   * Hide news if there is no news
   */
  var related = document.querySelectorAll("[data-related-blog-articles],[data-related-product-articles]");
  if (related) {
    related.forEach(function (el) {
      // if .article is 0 then hide the whole section
      if (el.querySelectorAll(".article").length > 0) {
        el.classList.remove("hidden");
      } else {
        el.classList.add("hidden");
      }
    });
  }

  /**
   * Category scroller
   */
  var categories = document.querySelector(".categories__blocks-scroller");
  if (categories) {
    var flkty = new Flickity(categories, {
      cellAlign: "center",
      contain: true,
      prevNextButtons: false,
      pageDots: true,
      groupCells: true
    });
  }
  var filterTrigger = document.querySelector("#trigger-collection-filter");
  if (filterTrigger) {
    filterTrigger.addEventListener("click", function (e) {
      e.preventDefault();
      document.body.classList.add("page--locked");
      document.body.classList.add("show-collection-filter");
      return false;
    });
  }
  var sortFilter = document.querySelector("#trigger-collection-sort");
  if (sortFilter) {
    sortFilter.addEventListener("click", function (e) {
      e.preventDefault();
      document.body.classList.add("page--locked");
      document.body.classList.add("show-collection-sort");
      return false;
    });
  }
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      document.body.classList.remove("page--locked");
      document.body.classList.remove("show-collection-sort");
      document.body.classList.remove("show-collection-filter");
    }
  });
  var closeFilter = document.querySelectorAll(".collection--mobile_slide-close-btn");
  if (closeFilter.length > 0) {
    closeFilter.forEach(function (el) {
      el.addEventListener("click", function (e) {
        e.preventDefault();
        document.body.classList.remove("page--locked");
        document.body.classList.remove("show-collection-sort");
        document.body.classList.remove("show-collection-filter");
        return false;
      });
    });
  }
  var overlay = document.querySelector(".page-overlay");
  if (overlay) {
    overlay.addEventListener("click", function () {
      if (document.body.classList.contains("show-collection-filter") || document.body.classList.contains("show-collection-sort")) {
        document.body.classList.remove("page--locked");
        document.body.classList.remove("show-collection-sort");
        document.body.classList.remove("show-collection-filter");
      }
    });
  }
  var sortForm = document.querySelector("#collection-sort");
  if (sortForm) {
    sortForm.querySelectorAll("input[name=sort]").forEach(function (input) {
      return input.addEventListener("change", function (e) {
        localStorage.setItem("collectionSort", e.target.value);
      });
    });
    if (localStorage.getItem("collectionSort")) {
      var i = sortForm.querySelector("input[value=\"".concat(localStorage.getItem("collectionSort"), "\"]"));
      if (i) {
        i.checked = true;
      }
    }
  }
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  init: init
});

/***/ }),

/***/ "./frontend/js/newsletter.js":
/*!***********************************!*\
  !*** ./frontend/js/newsletter.js ***!
  \***********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
var init = function init() {
  var form = document.querySelector(".c-modal__newsletter-form");
  var newsletter = document.querySelector(".c-modal__newsletter");
  if (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      newsletter.classList.add("c-modal__completed");
      fetch("https://clinicians-quiz.herokuapp.com/api/subscribe", {
        method: "POST",
        body: JSON.stringify(Object.fromEntries(new FormData(form))),
        headers: {
          "Content-Type": "application/json"
        }
      }).then(function (response) {
        return response.text();
      }).then(function (data) {
        console.log(data);
      })["catch"](function (error) {
        console.error("Error:", error);
      });
    });
  }
  var footerForm = document.getElementById("ContactFooter");
  if (footerForm && newsletter) {
    footerForm.addEventListener("submit", function (e) {
      e.preventDefault();
      newsletter.classList.remove("c-modal__hidden");
      document.getElementById("c-modal--email_name").focus();
      document.getElementById("c-modal--email_email").setAttribute("value", document.querySelector("#NewsletterForm--footer").value);
      return false;
    });
    newsletter.querySelector(".c-modal-close").addEventListener("click", function (e) {
      e.preventDefault();
      newsletter.classList.add("c-modal__hidden");
      newsletter.classList.remove("c-modal__completed");
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        newsletter.classList.add("c-modal__hidden");
        newsletter.classList.remove("c-modal__completed");
      }
    });
  }
  var pageLinks = document.querySelectorAll('[href="#newsletter"]');
  if (pageLinks && newsletter) {
    pageLinks.forEach(function (link) {
      link.addEventListener("click", function (e) {
        e.preventDefault();
        newsletter.classList.remove("c-modal__hidden");
        document.getElementById("c-modal--email_name").focus();
      });
    });
  }
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  init: init
});

/***/ }),

/***/ "./frontend/js/product-carousel.js":
/*!*****************************************!*\
  !*** ./frontend/js/product-carousel.js ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
var init = function init() {
  var targetNode = document.querySelector(".product__carousel");
  if (targetNode) {
    var flkty = new Flickity(targetNode, {
      cellAlign: "center",
      contain: true,
      wrapAround: true
    });
    flkty.once("ready", function () {
      window.dispatchEvent(new Event("resize"));
    });
  }
  var productBlogs = document.querySelector(".product__blog");
  if (productBlogs) {
    var productBlogcarousel = new Flickity(productBlogs, {
      imagesLoaded: true,
      cellAlign: "left",
      contain: true,
      groupCells: true,
      pageDots: true,
      adaptiveHeight: true,
      prevNextButtons: true,
      arrowShape: "M 25,50 L 50,80 L 60,80 L 35,50  L 60,20 L 50,20 Z"
    });
    window.onresize = function (event) {
      productBlogcarousel.resize();
      // productBlogs.querySelector(".flickity-viewport").style.height = null;
    };
  }
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  init: init
});

/***/ }),

/***/ "./frontend/js/promo.js":
/*!******************************!*\
  !*** ./frontend/js/promo.js ***!
  \******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
var init = function init() {
  var calculatePromo = function calculatePromo() {
    var promo = document.querySelector(".shipping__promo");
    if (promo) {
      var node = document.querySelector(".shipping-threshold");
      if (node) {
        var threshold = parseInt(node.dataset.expected, 10);
        var value = parseInt(node.dataset.total);
        if (Number.isNaN(value) || value > threshold) {
          promo.classList.add("shipping__promo--calculated");
          promo.classList.add("shipping__promo--achieved");
          node.innerText = "$0";
        } else {
          promo.classList.add("shipping__promo--calculated");
          promo.classList.remove("shipping__promo--achieved");
          var dollar = "$".concat((threshold - value) / 100);

          // always ensure dollar ends in at least 2 after decimal
          if (dollar.indexOf(".") === -1) {
            dollar += ".00";
          } else if (dollar.indexOf(".") === dollar.length - 2) {
            dollar += "0";
          }
          node.innerText = dollar;
        }
      }
    }
  };
  calculatePromo();
  var reloadIfEmpty = function reloadIfEmpty() {
    var cart = document.querySelectorAll(".cart-item:not(.removed)");
    if (cart.length === 0) {
      Douglas.hideSidecart();
      window.location.reload();
    }
  };
  document.body.addEventListener("cart__updated", calculatePromo);
  document.body.addEventListener("cart__updated", reloadIfEmpty);
  document.body.addEventListener("calculate__promo", calculatePromo);
  var processWorksWell = function processWorksWell() {
    var worksWith = document.getElementById("works-with");
    if (worksWith) {
      var denyList = worksWith.dataset.denyList;
      if (denyList) {
        denyList = denyList.split(",");
        worksWith.querySelectorAll("tr").forEach(function (row) {
          var sku = row.dataset.productId;
          if (denyList.includes(sku)) {
            row.remove();
          }
        });
      }
      var existingProducts = Object.entries(document.querySelectorAll(".main-cart-items-table .cart-item")).map(function (item) {
        if (item[1].dataset) {
          return item[1].dataset.productId;
        }
      }).filter(function (item) {
        return item;
      });
      worksWith.querySelectorAll(".cart-items tr").forEach(function (row) {
        var sku = row.dataset.productId;
        if (existingProducts.includes(sku)) {
          row.remove();
        }
      });
      if (worksWith.querySelectorAll("tr").length === 0) {
        worksWith.classList.add("hidden");
      } else {
        worksWith.classList.remove("hidden");
      }
    }
  };
  processWorksWell();
  document.body.addEventListener("cart__updated", processWorksWell);
  document.body.addEventListener("calculate__promo", processWorksWell);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  init: init
});

/***/ }),

/***/ "./frontend/js/upsell.js":
/*!*******************************!*\
  !*** ./frontend/js/upsell.js ***!
  \*******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/**
 * Handles when the user selects an upsell from a product.
 *
 * @param {*} event
 * @returns
 */
var handleUpsell = function handleUpsell(event) {
  var selectedValue = event.target.value;
  var dropdown = event.target;
  var root = window.Shopify.routes.root;
  var isSideCartOpen = document.querySelector(".side-cart.in");
  if (selectedValue) {
    // add a loading state to the parent .product-upsell
    dropdown.closest(".product-upsell").classList.add("loading");

    // convert the selected item to a selling plan
    var variantId = dropdown.dataset.variantId;
    var count = dropdown.dataset.count;
    fetch("".concat(root, "cart/change.js?quantity=0&id=").concat(variantId)).then(function (response) {
      if (isSideCartOpen) {
        fetch("".concat(root, "cart/add.js?quantity=").concat(count, "&id=").concat(variantId, "&selling_plan=").concat(selectedValue)).then(function () {
          Douglas.showSidecart();
        })["catch"](function () {
          window.location.reload();
        });
      } else {
        // On the cart page
        fetch("".concat(root, "cart/add.js?quantity=").concat(count, "&id=").concat(variantId, "&selling_plan=").concat(selectedValue)).then(function (response) {
          return response.json();
        }).then(function (data) {
          window.location.href = "/cart";
        })["catch"](function () {
          window.location.reload();
        });
      }
    })["catch"](function (e) {
      window.location.reload();
    });
  }
};
var init = function init() {
  var parentElement = document.body;
  parentElement.addEventListener("change", function (event) {
    // Check if the target of the event is a select element with the specified class
    if (event.target) {
      if (event.target.matches(".product-upsell select")) {
        handleUpsell(event);
      }
    }
  });

  // if input[name=bsub-selling-plan-group] has a value other than 'once' trigger a change event on it
  var subscriptionInput = document.querySelector("input[name=bsub-selling-plan-group]:checked");
  if (subscriptionInput && subscriptionInput.value !== "once") {
    subscriptionInput.dispatchEvent(new Event("change"));
  }
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  init: init
});

/***/ }),

/***/ "./frontend/js/wave.js":
/*!*****************************!*\
  !*** ./frontend/js/wave.js ***!
  \*****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function Wave() {
  var waveImg = document.querySelector('.js-wave');
  var ProductWaveImg = document.querySelector('.js-wave--product');
  var ratio;

  // Function to adjust the height of the wave image
  function adjustHeight(ratio) {
    // Get the current width of the document
    var screenWidth = document.documentElement.clientWidth;

    // Calculate a new height based on the ratio and screen width
    var niceHeight = screenWidth * ratio;

    // Set the calculated height for the wave image
    waveImg.style.height = niceHeight + 'px';
  }
  if (waveImg) {
    // Define a ratio based on the width/height of the wave SVG image
    ratio = 104 / 1440; // The width/height of the wave svg image
  }

  if (ProductWaveImg) {
    ratio = 68 / 1440; // The width/height of the wave svg image
  }

  if (waveImg) {
    // Adjust the wave height when the page loads
    adjustHeight(ratio);

    // Adjust the wave height when the page resizes
    window.addEventListener("resize", function () {
      adjustHeight(ratio);
    });
  }
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Wave);

/***/ }),

/***/ "./frontend/scss/phloe.scss":
/*!**********************************!*\
  !*** ./frontend/scss/phloe.scss ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/assets/custom": 0,
/******/ 			"assets/phloe": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkphloe"] = self["webpackChunkphloe"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["assets/phloe"], () => (__webpack_require__("./frontend/js/app.js")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/phloe"], () => (__webpack_require__("./frontend/scss/phloe.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;